var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E9EAEF"
    },
    points: "446.609,210.711 446.609,501.284 65.397,501.284 65.397,210.711 257.078,24.769 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#9EB1B7"
    },
    points: "353.334,108.119 353.334,54.445 448.637,54.445 448.637,198.88 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.25,
    y: 440.391,
    style: {
      fill: "#85C10D"
    },
    width: 230.147,
    height: 60.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.604,
    y: 440.391,
    style: {
      fill: "#85C10D"
    },
    width: 80.683,
    height: 60.893
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D2D4D8"
    },
    points: "446.609,222.117 446.609,276.43 256.003,94.442 65.397,276.43 65.397,222.117  240.866,55.003 256.003,40.94 271.13,55.003 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EA4756"
    },
    points: "256,64.218 38.982,271.411 8.637,245.938 240.868,24.77 256,10.714 271.131,24.77  503.362,245.938 473.017,271.411 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.032,
    y: 283.577,
    style: {
      fill: "#C97523"
    },
    width: 125.719,
    height: 217.706
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.25,
    y: 283.577,
    style: {
      fill: "#A0D9F2"
    },
    width: 143.167,
    height: 125.719
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.25,
    y: 283.577,
    style: {
      fill: "#C97523"
    },
    width: 143.167,
    height: 38.202
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#413740"
    },
    cx: 256,
    cy: 186.439,
    r: 34.976
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.649,283.578v125.719c0,4.199,3.404,7.604,7.604,7.604h143.163c4.2,0,7.604-3.405,7.604-7.604V283.578 c0-4.199-3.404-7.604-7.604-7.604H274.253C270.052,275.974,266.649,279.378,266.649,283.578z M281.857,401.692v-72.309h127.955 v72.309H281.857z M409.812,291.182v22.994H281.857v-22.994H409.812z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M504.396,432.792h-50.183v-168.82l13.553,12.94c1.464,1.398,3.356,2.104,5.252,2.104c1.734,0,3.47-0.59,4.888-1.78 l30.179-25.333c1.018-0.855,1.866-1.918,2.348-3.156c1.165-2.986,0.36-6.231-1.826-8.315l-52.366-49.871v-71.977 c0-4.199-3.405-7.604-7.604-7.604l0,0c-4.199,0-7.604,3.405-7.604,7.604v57.494l-80.095-76.279V62.049h80.095v21.048 c0,4.199,3.405,7.604,7.604,7.604l0,0c4.199,0,7.604-3.405,7.604-7.604V54.445c0-4.199-3.405-7.604-7.604-7.604h-95.303 c-4.199,0-7.604,3.405-7.604,7.604v30.87l-69.424-66.116L261.175,5.143c-2.919-2.711-7.434-2.71-10.351,0l-15.2,14.121 L3.393,240.431c-2.186,2.083-2.991,5.328-1.826,8.315c0.483,1.238,1.33,2.301,2.348,3.156l30.179,25.334 c2.969,2.492,7.336,2.352,10.14-0.324l13.56-12.947v49.771c0,4.199,3.405,7.604,7.604,7.604l0,0c4.199,0,7.604-3.405,7.604-7.604 v-64.291L256,74.73l183.005,174.722v183.341H274.253c-4.199,0-7.604,3.405-7.604,7.604v53.284h-21.291V283.579 c0-4.199-3.405-7.604-7.604-7.604H112.035c-4.199,0-7.604,3.405-7.604,7.604v210.102h-8.545v-53.284 c0-4.199-3.405-7.604-7.604-7.604H73.001v-83.57c0-4.199-3.405-7.604-7.604-7.604l0,0c-4.199,0-7.604,3.405-7.604,7.604v83.57H7.604 c-4.199,0-7.604,3.405-7.604,7.604v60.889c0,4.199,3.405,7.604,7.604,7.604h80.678c0.007,0,0.013-0.001,0.019-0.001h23.732h125.719 h36.48c0.006,0,0.013,0.001,0.019,0.001h230.145c4.199,0,7.604-3.405,7.604-7.604v-60.889 C512,436.196,508.595,432.792,504.396,432.792z M256,56.614c-1.891,0-3.781,0.702-5.251,2.104L38.657,261.21l-18.618-15.63 L246.044,30.341L256,21.092l9.886,9.185L491.961,245.58l-18.619,15.63L261.251,58.717C259.781,57.315,257.891,56.614,256,56.614z  M15.208,448h65.47v45.681H65.397v0.001H15.208V448z M119.639,493.68V291.182H230.15V493.68L119.639,493.68L119.639,493.68z  M496.792,493.681h-50.183v-0.001H281.857V448h214.936V493.681z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.981,384.129h-18.249c-4.2,0-7.604,3.405-7.604,7.604c0,4.199,3.404,7.604,7.604,7.604h18.249 c4.2,0,7.604-3.405,7.604-7.604C220.585,387.534,217.181,384.129,212.981,384.129z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256.003,143.856c-23.479,0-42.58,19.101-42.58,42.581c0,23.479,19.101,42.58,42.58,42.58s42.58-19.101,42.58-42.58 C298.583,162.958,279.482,143.856,256.003,143.856z M256.003,213.809c-15.093,0-27.372-12.279-27.372-27.372 c0-15.093,12.279-27.373,27.372-27.373s27.372,12.279,27.372,27.373C283.375,201.53,271.096,213.809,256.003,213.809z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHome);
export default __webpack_public_path__ + "static/media/menu-home.12fdb3b1e02a6175da1afa3c1b487156.svg";
export { ForwardRef as ReactComponent };